import { render } from "./ReverseWhenFocusButton.vue?vue&type=template&id=7a118ccc&scoped=true"
import script from "./ReverseWhenFocusButton.vue?vue&type=script&lang=js"
export * from "./ReverseWhenFocusButton.vue?vue&type=script&lang=js"

import "./ReverseWhenFocusButton.vue?vue&type=style&index=0&id=7a118ccc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7a118ccc"

export default script